import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterGenreControlsLogic} from "./FilterGenreControls.logic";
import {
  SelectAndResetFilterControls
} from "../../../components/songs/songs-filters/select-and-reset-filter-controls/SelectAndResetFilterControls";

export const FilterGenreControls: VoidFunctionComponent = () => {
  const {handleResetOnClick} = useFilterGenreControlsLogic();
  return <SelectAndResetFilterControls onReset={handleResetOnClick} customLabel={`Reset genre filters`} ariaLabel={`Reset the genre filters to show all`} />;
}
